/**
 * Replaces template variables in the format [key] with values from a vars object.
 * @param {string} text_template - The template with one or more dynamic variables to swap in
 * @param {Record<string, string | null>} vars - Key-value pairs of variables to swap into the template
 * @returns {string} The formatted text string
 */
export function formatTextTemplate(text_template, vars) {
  let result = text_template;
  for (const key in vars) {
    if (vars[key] === null) {
      continue;
    }
    result = result.replaceAll(`[${key}]`, vars[key]);
  }
  return result;
}
